<script lang="ts">
  interface Option {
    value: string;
    label: string;
    description?: string;
  }

  interface Props {
    kind: 'checkbox' | 'radio';
    legend: string;
    hideLegend?: boolean;
    instruction?: string;
    options: Option[];
    selected: string[];
    onToggle: (value: string) => void;
    inline?: boolean;
    describedBy?: string;
  }

  let {
    kind,
    legend,
    hideLegend = false,
    instruction,
    options,
    selected,
    onToggle,
    inline = false,
    describedBy,
  }: Props = $props();

  const name = $props.id();
  const ariaDescribedBy = $derived(
    [instruction ? `${name}-instruction` : '', describedBy ?? ''].filter(Boolean).join(' ') || undefined
  );
</script>

<fieldset class="stat-choice-group" aria-describedby={ariaDescribedBy}>
  <legend class={hideLegend ? 'stat-visually-hidden' : 'stat-label'}>{legend}</legend>
  {#if instruction}
    <p class="stat-meta" id="{name}-instruction" style="margin-bottom: var(--stat-space-3)">{instruction}</p>
  {/if}
  {#each options as option (option.value)}
    <label class={inline ? 'stat-choice stat-choice--inline' : 'stat-choice'}>
      <input
        type={kind}
        {name}
        value={option.value}
        checked={selected.includes(option.value)}
        onchange={() => onToggle(option.value)}
      />
      <span class="stat-choice__text">
        <span>{option.label}</span>
        {#if option.description}<span class="stat-meta">{option.description}</span>{/if}
      </span>
    </label>
  {/each}
</fieldset>
